import React from "react";
import "./faqs.css";
import QuestionsTab from "./QuestionsTab";

function FAQs() {
  return (
    <div className="faq-wrapper">
      <div className="faq-heading">
       Got Questions? We’ve Already  
        <span style={{ color: "#6D2FEC" }}>
          {" "}
          Verified
          {" "}
        </span>
        <br />
        the Answers
      </div>
      <div className="faq-questions-tab">
        <QuestionsTab
          ques={"What is IdProof?"}
          ans={
            "IdProof is BeFiSc’s API suite for ID verification, employment, and business checks built to stop fraud and power digital onboarding workflows."
          }
        />
        <QuestionsTab
          ques={"How accurate are the checks?"}
          ans={
            "Our ID verification APIs connect to trusted data sources, ensuring over 99% accuracy for validation, document parsing, and fraud detection."
          }
        />
        <QuestionsTab
          ques={"Can I choose only the APIs I need?"}
          ans={
            "Yes. You can integrate specific checks or combine multiple KYC verification APIs into a single workflow suited to your business needs."
          }
        />
        <QuestionsTab
          ques={"How fast are responses?"}
          ans={
            "Most ID verification results return in under 3 seconds, enabling real-time KYC onboarding decisions without slowing down approvals."
          }
        />
        <QuestionsTab
          ques={"Does IdProof support large-scale verifications?"}
          ans={
            "Yes. IdProof handles enterprise-scale digital ID verifications with 99.9% uptime, processing thousands of checks daily without disruption."}
        />
        <QuestionsTab
        ques={"Can IdProof handle multiple checks in one workflow?"}
        ans={"Yes. You can combine APIs like Face Match, OCR, and Name Match into one streamlined ID verification workflow."}
        />
      </div>
    </div>
  );
}

export default React.memo(FAQs);
